import { controls } from "../../controls";

const rp1041= {
  label: "OSC 4.1.5",
  pageLabel: "OSC 4.1.5",
  starting: true,
  url: "rp1041",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [  
   
    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
    
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Medium and Long Term loans - Others",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
        {
            Header:"Sr. No.",
            accessor:"Sr._No.",
            rwidth:"*"
        },

        {
            Header:"Particulars",
            accessor:"particulars",
            rwidth:"*"
        },

       
        {
            Header: "Classification Of Asset",
            columns:[
                {
                    Header: "Standard Asset",
                    accessor: "standard_asset",
                    rwidth:"*"
                  },
                  {
                    Header: "Sub Standard Over Due Up To 3 Years",
                    accessor: "sub_standard_over_due",
                    rwidth:"*"
                  },

                  {
                    Header: "Doubtful Secured",
                    columns:[
                        {
                            Header: "Over Dues For 3 To 4 years",
                            accessor: "over_dues_for_3_to_4_years",
                            rwidth:"*"
                          },
                          {
                            Header: "Over Dues For 4 To 6 years",
                            accessor: "over_dues_for_4_to_6_years",
                            rwidth:"*"
                          },
                          {
                            Header: "Overdues For More Than Years",
                            accessor: "overdues_for_more_than_6_years",
                            rwidth:"*"
                          }
            
                    ]
                },
            {
                 Header: "Doubtful Unsecured",
                accessor: "doubtful_unsecured",
                rwidth:"*"
            },
            {
                Header: "Losses Asset",
                accessor: "losses_asset",
                rwidth:"*"
            }
    
            ]
        },

                  
        {
            accessor: "recoveries_made_out_of_previous_years_NPAs_during_the_year",
            Header: "Recoveries made out of previous years NPAs during the year",
            rwidth:"*"
        }
                  
            
    ]
  }
};

export default rp1041;